/**
 * Created by Languagenut on 09/12/2019.
 */


import React from 'react';
import Base from '../wizards/assignments/activities_type.js';
import BootstrapTable from 'react-bootstrap-table-next';
import {Form , ProgressBar , Row , Col , Navbar  , Nav,Button } from 'react-bootstrap'
import LanguageSelect from '../language_select.js';
import AccountStore from '../../store/account-store.js';
import ContentSelection from  '../wizards/assignments/content.js';
import Package from '../../classes/package.js';
import Translation from '../../store/internationalization-store.js'

class Activities extends Base.component {

    constructor(props) {
        super();
        this.props = {}
        this.props.data = {};
        this.state = {
            key:0
        }
    }

    set(){
        this.setLanguageValue.apply(this , arguments);
        this.setState({
            key:0
        })
    }

    render(){

        const columns = [{
            dataField: 'title', 
            text: Translation.get(14 , 'Name'),
          //  formatter: this.renderlink.bind(this),
        }];

        let options = this.getTasks();
        let buttons =  <BootstrapTable  bordered={ true } keyField='id' data={ options || [] } columns={ columns } />;;



        if(!this.state.loaded ||
            AccountStore.curriculumData.startScreen == undefined) buttons = <ProgressBar animated now={45} animated />

        let items = [];
        let selected = '';
        let navBars = [];
        for(var i = 0; i < options.length; i++)
        {   
            if (items.length > 0 && items.length % 8 == 0) {
                navBars.push(<Navbar style={{paddingLeft:0}} >
                    <Nav activeKey={this.state.key} className="mr-auto" onSelect={(selectedKey)=>{ this.setState({key:selectedKey}) }} >
                        {items}
                    </Nav>
                    </Navbar>)
                items = [];
            }
            selected = options[this.state.key].uid
            if (options[i].title == "Exam Skills") {
                continue;
            }
            items.push(
                <Nav.Item>
                    <Nav.Link eventKey={i} >{options[i].title}</Nav.Link>
                </Nav.Item>
            )
        }
        navBars.push(<Navbar style={{paddingLeft:0}} >
            <Nav activeKey={this.state.key} className="mr-auto" onSelect={(selectedKey)=>{ this.setState({key:selectedKey}) }} >
                {items}
            </Nav>
            </Navbar>)

        let type = "";

        if(options[this.state.key])
        {
            type = options[this.state.key].uid
        }

        var buttonStuff = [<Col md={"auto"}>
                            <div class="d-flex align-items-left">
                                <div class="p-2 report_title">
                                    {Translation.get(123 , 'Content Map')}
                                </div>
                            </div>
                        </Col>,
                        <Col md={3}>
                            <div class="d-flex align-items-right">
                                <Button onClick={function(){window.open("https://storage.languagenut.com/Content Map.pdf")}}>{Translation.get(12650 , 'Download Content Map')}</Button>
                            </div>
                        </Col>,
                        <Col md={2}>
                        <Form style={{float:"right"}} inline>
                            <LanguageSelect limitLanguages={this.props.classLanguages} returnValue={this.set.bind(this)} />
                        </Form>
                        </Col>]
        if((new Package()).isSecondary()) {
            buttonStuff = [<Col md={10}>
                                <div class="d-flex align-items-left">
                                    <div class="p-2 report_title">
                                        {Translation.get(123 , 'Content Map')}
                                    </div>
                                </div>
                            </Col>,
                            <Col md={2}>
                            <Form style={{float:"right"}} inline>
                                <LanguageSelect limitLanguages={this.props.classLanguages} returnValue={this.set.bind(this)} />
                            </Form>
                            </Col>]
        }

        return <div>
            <Row>
            {buttonStuff}
            </Row>
            <Row>
                <Col md={12}>
                    {navBars}
                </Col>
            </Row>
            <ContentSelection data={{types:[type] , counter:[0] , language:this.language}}  />
        </div>;
    }
}

export default class ContentMap extends React.Component {

    constructor(props) {
        super();
    }

    render(){

        return <Activities />
    }
}